import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type KvkkLedgerRow = {
  id: string;
  company_id: string | null;
  customer_id: string | null;
  phone: string;
  event_type: "grant" | "withdraw";
  consent_status: "granted" | "withdrawn";
  policy_version_id: string;
  policy_url: string | null;
  consent_text_snapshot: string;
  consent_method: string;
  consent_source: string;
  withdraw_method: string | null;
  request_id: string | null;
  ip_address: string | null;
  user_agent: string | null;
  device_type: string | null;
  sms_message_sent: string | null;
  sms_reply_received: string | null;
  sms_sent_at: string | null;
  sms_replied_at: string | null;
  link_expires_at: string | null;
  evidence_snapshot: Record<string, unknown> | null;
  pdf_storage_path: string | null;
  created_at: string;
};

export const useKvkkConsentLedger = (phone: string | null, refreshToken = 0) => {
  return useQuery({
    queryKey: ["kvkk-consent-ledger", phone, refreshToken],
    enabled: !!phone && phone.trim().length > 0,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_kvkk_consent_history", {
        p_phone: phone!,
      });

      if (error) {
        throw new Error(error.message || "KVKK consent history fetch failed");
      }

      const rows = (data || []) as KvkkLedgerRow[];
      return {
        latest: rows.length > 0 ? rows[0] : null,
        history: rows,
      };
    },
    staleTime: 15_000,
  });
};
